import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Chat = forwardRef<SVGSVGElement, SvgIconProps>(function Chat(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path d="M17.5 9.4c.73.13 1.42.46 1.97.96a4.58 4.58 0 01-.4 7.1c-.38.22-.78.4-1.19.54-.17.06-.21.12-.21.29v1.42a.73.73 0 01-.24.6.68.68 0 01-.96-.07c-.29-.28-.56-.57-.83-.86l-1.07-1.11a.4.4 0 00-.32-.13 10.85 10.85 0 01-1.57-.08 3.9 3.9 0 01-2.72-1.95c-.12-.18-.02-.35.2-.35h.82a6.23 6.23 0 005.7-3.5c.46-.84.73-1.78.8-2.74l.02-.12zM10.9 3.1c2.1-.01 3.67.92 4.75 2.67a6.15 6.15 0 01-.93 7.54A5.17 5.17 0 0111 14.78H9.84a.42.42 0 00-.34.14l-2.59 2.72a.86.86 0 01-.65.3.78.78 0 01-.78-.8v-2.26c0-.14-.04-.2-.18-.23a5.47 5.47 0 01-4.06-3.99c-.1-.39-.18-.78-.24-1.18V8.4c.04-.35.1-.7.2-1.03a5.57 5.57 0 013.51-3.98 4.7 4.7 0 011.68-.29h4.51z" />
    </SvgIcon>
  )
})

export default Chat
